import SettingLoader from './components/settingLoader';

const outLoader = () => {
    return {
        Setting: SettingLoader,
    };
};

export default outLoader;
